import { ListItem, ListItemButton } from '@mui/material';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { useUserThemeContext } from '@src/main/ui/providers/user/UserThemeContextProvider';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './DrawerLogo.module.scss';

const DrawerLogo: FC = () => {
  const { theme } = useUserThemeContext();
  const navigate = useNavigate();

  return (
    <ListItem key="iberia" disablePadding>
      <ListItemButton component="a" onClick={() => navigate('/')}>
        <div className={styles.drawerLogo__button}>
          <Icon iconId={theme === 'Corporate' ? 'iberia-dark' : 'iberia'} />
        </div>
      </ListItemButton>
    </ListItem>
  );
};

export default DrawerLogo;
